import { $starGet, $get, $planPost } from '../axios';
//获取星启计划3.0内容
export const fetchStarContent = params => {
  return $starGet('/api/pub/article/2068', { ...params });
};
export const fetchStarProduct = params => {
  return $get('/creator/', { act: 'get_xq_maps', ...params });
};
//参与星启计划时长激励
export const takeStarPlan = params => {
  return $planPost('/incentiveUser/apply', params);
};
//下载工作室数据
export const exportStudioData = params => {
  return $get('/creator/', { act: 'export_xq_maps', ...params });
};
